import React, { useState, useRef, useEffect } from 'react';
import './SortDropdown.css';

/**
 * SortDropdown - Aurora-compliant sort/filter dropdown
 * Uses design tokens for consistent styling
 */
const SortDropdown = ({ 
  options = ['Recommendation', 'Price', 'Category'],
  defaultValue = 'Recommendation',
  onChange,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  const handleSelect = (option) => {
    setSelectedValue(option);
    setIsOpen(false);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <div 
      ref={dropdownRef}
      className={`sort-dropdown ${className}`}
    >
      <button
        type="button"
        className="sort-dropdown__trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span className="sort-dropdown__label">{selectedValue}</span>
        <svg
          className={`sort-dropdown__icon ${isOpen ? 'sort-dropdown__icon--open' : ''}`}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4 6L8 10L12 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div 
          className="sort-dropdown__menu"
          role="listbox"
          aria-label="Sort options"
        >
          {options.map((option) => (
            <button
              key={option}
              type="button"
              className={`sort-dropdown__option ${
                selectedValue === option ? 'sort-dropdown__option--selected' : ''
              }`}
              onClick={() => handleSelect(option)}
              role="option"
              aria-selected={selectedValue === option}
            >
              {option}
              {selectedValue === option && (
                <svg
                  className="sort-dropdown__check"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3334 4L6.00002 11.3333L2.66669 8"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
